export default {
    title_list: 'Memberships',
    title_page: 'Membership',
    title_create_page: 'Create a Membership',
    title_edit_page: 'Change Membership',

    labels: {
        permissions_table: 'Permissions',
        permission: 'Resolution',
        value: 'Value',
        select_permission: 'Select resolution',
        add_permission: 'Add permission',
        plan_updated: 'Tariff plans have been updated',
    },

    filter: {
        labels: {
            title: 'Title',
            slug: 'Braintree ID',
        }
    },

    table: {
        labels: {
            id: 'ID',
            slug: 'Braintree ID',
            title: 'Title',
            price: 'Cost',
            active: 'Displayed for purchase',
        }
    },

    buttons: {
        update_plans: 'Synchronization with Braintree'
    },

    form: {
        slug: 'Braintree ID',
        title: 'Title',
        promo_label: 'Promo label',
        price: 'Cost',
        position: 'Order',
        active: 'Displayed for purchase',
        priority: 'Priority',
    },
}
